const MEDIA_ITEMS = [
  {
    id: 1,
    title: '动作大片：极限追凶',
    duration: '128分钟',
    quality: '4K超清',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20thriller%20movie%20scene%20atmosphere%20with%20dramatic%20urban%20night%20lighting%2C%20film%20noir%20aesthetic%2C%20warm%20golden%20and%20deep%20shadow%20contrast%2C%20suspenseful%20composition%2C%20no%20text%2C%20no%20faces%2C%20atmospheric%20cityscape&width=600&height=340&seq=media-01-action&orientation=landscape',
    views: '86万次播放',
  },
  {
    id: 2,
    title: '科幻巨制：深空救援',
    duration: '156分钟',
    quality: '杜比视界',
    image: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20cinematic%20atmosphere%20with%20nebulae%20and%20stars%2C%20deep%20blue%20and%20gold%20cosmic%20lighting%2C%20futuristic%20film%20aesthetic%2C%20no%20text%2C%20no%20faces%2C%20grand%20scale%20composition&width=600&height=340&seq=media-02-scifi&orientation=landscape',
    views: '124万次播放',
  },
  {
    id: 3,
    title: '温情剧情：小城故事',
    duration: '112分钟',
    quality: '1080P',
    image: 'https://readdy.ai/api/search-image?query=Warm%20heartfelt%20drama%20film%20aesthetic%20with%20golden%20hour%20sunset%20lighting%20through%20window%2C%20intimate%20storytelling%20atmosphere%2C%20soft%20textures%20and%20nostalgic%20tones%2C%20no%20text%2C%20no%20faces%2C%20peaceful%20composition&width=600&height=340&seq=media-03-drama&orientation=landscape',
    views: '63万次播放',
  },
  {
    id: 4,
    title: '悬疑大片：迷雾之夜',
    duration: '135分钟',
    quality: '4K超清',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20suspense%20thriller%20film%20aesthetic%20with%20foggy%20atmospheric%20lighting%2C%20film%20noir%20shadows%20and%20high%20contrast%2C%20dramatic%20cinematic%20composition%2C%20no%20text%2C%20no%20faces%2C%20tense%20moody%20atmosphere&width=600&height=340&seq=media-04-suspense&orientation=landscape',
    views: '97万次播放',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选放映厅
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            高清电影在线观看精选推荐，每部都是品质之选，点击即享不缓冲影院级观影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/30 hover:border-primary-500/20 transition-all duration-300 cursor-pointer group"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3 px-2 py-0.5 rounded text-[10px] font-medium bg-background-50/80 backdrop-blur-sm text-foreground-700">
                  {item.quality}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-accent-500/90 flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-foreground-950 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-1.5">{item.title}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{item.duration}</span>
                  <span className="text-xs text-foreground-400">{item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}